type EventHandler = (...args: unknown[]) => void;

export class BackendServiceStub {
	private eventHandlers: Map<string, EventHandler[]> = new Map();

	// @TODO
	public async waitForInit() {}

	public getIsCreatingCharacter() {
		return true;
	}

	public async addEventHandler(
		eventName: string,
		handler: EventHandler,
	): Promise<void> {
		const handlers = this.eventHandlers.get(eventName) || [];
		handlers.push(handler);
		this.eventHandlers.set(eventName, handlers);
	}

	public async invoke(_method: string, _params?: unknown): Promise<unknown> {
		return null;
	}
}
